import numeral from "numeral";
import { formatDate } from "./DateHelper";
const NumeralHelper = (data, type) => {
  switch (type) {
    case 'money':
      data = numCheck(data);
      if(data==="-"){
        return data;
      }
      return "$" + numeral(data).format('0,0');
    case 'small-money':
      data = numCheck(data);
      return "$" + numeral(data).format('0,0.00');
    case 'no-decimal':
      data = numCheck(data);
      return "$" + numeral(data.toFixed(0)).format('0,0');
    case 'format-money':
      data = numCheck(data);
      return "$" + numeral(data).format('0,0.00');
    case 'format-decimal':
      data = numCheck(data);
      return numeral(data).format('0,0.00');
    case 'two-decimals':
      data = numCheck(data);
      return numeral(Number(data).toFixed(2)).format('0,0.00');
    case 'percentage':
      data = numCheck(data);
      return Math.round(data) + "%";
    case 'small-percentage':
      data = numCheck(data);
      return Number(data).toFixed(2) + "%";
    case 'percentage-with-comma':
      data = numCheck(data);
      return numeral(Math.round(data)).format('0,0') + "%";
    case 'date':
      return formatDate(data);
    case 'countable':
      if(data==="-"){
        return data;
      }
      data = numCheck(data);
      return parseInt(data)
    case 'phone':
      return formatPhoneNumber(data)
    case 'large-money':
      if(data==="-"){
        return data;
      }
      data = numCheck(data);
      return '$' + numeral(data).format("0,0")
    case 'large-countable':
      if(data==="-"){
        return data;
      }
      data = numCheck(data);
      return numeral(data).format('0,0')
    case 'unit-data':
      data = numCheck(data);
      if(Math.abs(Number(data)) >= 1.0e+9) {
        if((Math.abs(Number(data)) / 1.0e+9).toString().split('.')[0].length == 1) {
          return `$${(Math.abs(Number(data)) / 1.0e+9).toFixed(2) + "B"}`
        } else if((Math.abs(Number(data)) / 1.0e+9).toString().split('.')[0].length == 2) {
          return `$${(Math.abs(Number(data)) / 1.0e+9).toFixed(1) + "B"}`
        }
        return `$${(Math.abs(Number(data)) / 1.0e+9).toFixed(0) + "B"}`

      } else if(Math.abs(Number(data)) >= 1.0e+6) {
        if((Math.abs(Number(data)) / 1.0e+6).toString().split('.')[0].length == 1) {
          return `$${(Math.abs(Number(data)) / 1.0e+6).toFixed(2) + "M"}`
        } else if((Math.abs(Number(data)) / 1.0e+6).toString().split('.')[0].length == 2) {
          return `$${(Math.abs(Number(data)) / 1.0e+6).toFixed(1) + "M"}`
        }
        return `$${(Math.abs(Number(data)) / 1.0e+6).toFixed(0) + "M"}`

      } else if(Math.abs(Number(data)) >= 1.0e+3) {
        if((Math.abs(Number(data)) / 1.0e+3).toString().split('.')[0].length == 1) {
          return `$${(Math.abs(Number(data)) / 1.0e+3).toFixed(2) + "K"}`
        } else if((Math.abs(Number(data)) / 1.0e+3).toString().split('.')[0].length == 2) {
          return `$${(Math.abs(Number(data)) / 1.0e+3).toFixed(1) + "K"}`
        }
        return `$${(Math.abs(Number(data)) / 1.0e+3).toFixed(0) + "K"}`

      } else {
        if(Math.abs(Number(data)).toString().split('.')[0].length <= 2) {
          return `$${Math.abs(Number(data)).toFixed(2)}`
        }
        return `$${(Math.abs(Number(data))).toFixed(0)}`
      }
    case 'two-decimal-unit-data':
      data = numCheck(data);
      return Math.abs(Number(data)) >= 1.0e+9
      ? `$${(Math.abs(Number(data)) / 1.0e+9).toFixed(2) + "B"}`
      : Math.abs(Number(data)) >= 1.0e+6
      ? `$${(Math.abs(Number(data)) / 1.0e+6).toFixed(2) + "M"}`
      : Math.abs(Number(data)) >= 1.0e+3
      ? `$${(Math.abs(Number(data)) / 1.0e+3).toFixed(2) + "K"}`
      : `$${(Math.abs(Number(data))).toFixed(2)}`
    case 'format-unit-data':
      data = numCheck(data);
      if(Math.abs(Number(data)) >= 1.0e+9) {
        if((Math.abs(Number(data)) / 1.0e+9).toString().split('.')[0].length == 1) {
          return `$${(Math.abs(Number(data)) / 1.0e+9).toFixed(2) + "B"}`
        } else if((Math.abs(Number(data)) / 1.0e+9).toString().split('.')[0].length == 2) {
          return `$${(Math.abs(Number(data)) / 1.0e+9).toFixed(1) + "B"}`
        }
        return `${(Math.abs(Number(data)) / 1.0e+9).toFixed(0) + "B"}`

      } else if(Math.abs(Number(data)) >= 1.0e+6) {
        if((Math.abs(Number(data)) / 1.0e+6).toString().split('.')[0].length == 1) {
          return `${(Math.abs(Number(data)) / 1.0e+6).toFixed(2) + "M"}`
        } else if((Math.abs(Number(data)) / 1.0e+6).toString().split('.')[0].length == 2) {
          return `${(Math.abs(Number(data)) / 1.0e+6).toFixed(1) + "M"}`
        }
        return `${(Math.abs(Number(data)) / 1.0e+6).toFixed(0) + "M"}`

      } else if(Math.abs(Number(data)) >= 1.0e+3) {
        if((Math.abs(Number(data)) / 1.0e+3).toString().split('.')[0].length == 1) {
          return `${(Math.abs(Number(data)) / 1.0e+3).toFixed(2) + "K"}`
        } else if((Math.abs(Number(data)) / 1.0e+3).toString().split('.')[0].length == 2) {
          return `${(Math.abs(Number(data)) / 1.0e+3).toFixed(1) + "K"}`
        }
        return `${(Math.abs(Number(data)) / 1.0e+3).toFixed(0) + "K"}`

      } else {
        if(Math.abs(Number(data)) < 1000) {
          return `${Math.abs(Number(data)).toFixed(0)}`
        } else if(Math.abs(Number(data)).toString().split('.')[0].length <= 2) {
          return `${Math.abs(Number(data)).toFixed(2)}`
        }
        return `${Math.abs(Number(data)).toFixed(0)}`
      }
      
    case `money-absolute`:
      data = numCheck(data);
      if (data < 0) {
        return `($${numeral(Math.abs(data)).format("0,0")})`
      }
      else {
        return '$' + numeral(data).format("0,0")
      }
    case 'format-comma':
      data = numCheck(data);
      return numeral(data).format('0,0');
    default:
      return data
  }
}



let formatPhoneNumber = (str) => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  };

  return str
};

function numCheck(data) {
  if(data==="-"){
    return data;
  }
  if (!isFinite(data)) {
    return 0;
  }
  else if (isNaN(data)) {
    return 0
  }
  return data
}
export default NumeralHelper;